module.exports = __webpack_public_path__ + "media/smart_sales/ss_photo_1-890e412b.webp";